import IconBookOutline from 'images/icon-book-outline.svg';
import IconDesktopOutline from 'images/icon-desktop-outline.svg';
import IconSunnyOutline from 'images/icon-sunny-outline.svg';
import IconCogOutline from 'images/icon-cog-outline.svg';
import IconHelpCircleOutline from 'images/icon-help-circle-outline.svg';

export default {
  story: {
    name: 'story',
    icon: IconBookOutline,
    title: 'Stories',
  },

  example: {
    name: 'example',
    icon: IconDesktopOutline,
    title: 'Examples',
  },

  tip: {
    name: 'tip',
    icon: IconSunnyOutline,
    title: 'Tips',
  },

  resource: {
    name: 'resource',
    icon: IconCogOutline,
    title: 'Resources',
  },

  question: {
    name: 'question',
    icon: IconHelpCircleOutline,
    title: 'Questions',
  },
}
